import React from 'react';
import { Box, Typography } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../theme/color-palette';
import { Skeleton } from '@walmart-web/livingdesign-components';

const ShimmerSelect = () => {
	const useStyles = makeStyles(() => ({
		select: {
			width: '123px',
			height: '32px',
			border: `1px solid ${colors.SHIMMER_UI_GREY}`,
			marginLeft: '22px',
			marginTop: '25px',
			marginBottom: '25px',
		},
		text: {
			marginTop: '8.5% !important',
			marginLeft: '15% !important',
		},
	}));

	const classes = useStyles();

	return (
		<Box className={classes.select}>
			<Typography className={classes.text}>
				<Skeleton height="12.25px" width="78px" variant="rounded" />
			</Typography>
		</Box>
	);
};

export default ShimmerSelect;
